import { render, staticRenderFns } from "./友情链接1.vue?vue&type=template&id=3d004e9e&scoped=true"
import script from "./友情链接1.vue?vue&type=script&lang=js"
export * from "./友情链接1.vue?vue&type=script&lang=js"
import style0 from "./友情链接1.vue?vue&type=style&index=0&id=3d004e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d004e9e",
  null
  
)

export default component.exports